import type { SWRResponse } from "swr";
import { useFetcher } from "~/hooks/useFetcher";
import {
  AIRFLOW_RUN_TERMINAL_STATES,
  type DagRunStatus,
  type RunStatusAgent,
  runStatusPath,
} from "~/services/dagRuns";

// Pipeline runs take minutes, not seconds — eval-run/ingest's 3s default
// would be wasted load here.
const POLL_INTERVAL_MS = 30_000;

// dagId/runId are separate nullable params, not one composite id — they come
// from two different upstream sources (trigger args vs. its result) and both
// must resolve before the request fires. `agent` picks the run-status route;
// an unknown agent skips the request rather than guessing a route.
export const useDagRunStatus = (
  dagId: string | null,
  runId: string | null,
  agent: RunStatusAgent | undefined
): SWRResponse<DagRunStatus> =>
  useFetcher<DagRunStatus>(dagId && runId && agent ? runStatusPath(agent, dagId, runId) : null, {
    shouldCamelize: true,
    refreshInterval: (latest?: DagRunStatus) =>
      latest && AIRFLOW_RUN_TERMINAL_STATES.has(latest.state) ? 0 : POLL_INTERVAL_MS,
  });
